<template>
  <div class="table-container">
    <table aria-label="provider biography">
      <tbody>
      <tr>
        <td rowspan="60" width="20%">
          <img v-if="provider.gender === 'M'" src="@/assets/images/avatar-male.jpg" class="provider__avatar"/>
          <img v-else src="@/assets/images/avatar-female.jpg" class="provider__avatar"/>
        </td>
      </tr>
      <tr>
        <td class="provider__title capitalize">
          <!-- <span v-for="(specialty,index) in provider.specialties"
                :key="specialty.id+'_'+index+$route.path"><text-highlight :queries="keywords">{{ specialty.name.toLowerCase() }}</text-highlight></span> -->
            <span><text-highlight :queries="keywords || []">{{ specialty.replace(/\-/g,' ') }}</text-highlight></span>
        </td>
      </tr>
      <tr v-if="provider.affiliation">
        <td class="provider__info capitalize">
          <font-awesome-icon :icon="['fas', 'building']" class="icon"/>
          <b> Location:</b> {{ provider.affiliation.toLowerCase() }}
        </td>
      </tr>
      <tr v-if="provider.npi">
        <td class="provider__info capitalize">
          <font-awesome-icon :icon="['fas', 'arrow-right']" class="icon"/>
          <span><b>NPI:</b>{{ provider.npi }}</span>
        </td>
      </tr>
      <tr>
        <td class="provider__info capitalize">
          <font-awesome-icon :icon="['fas', 'map-marker-alt']" class="icon"/>
          <span v-if="provider.address1"> <b> Address:</b> {{ provider.address1.toLowerCase() }}</span>
          <span v-else style="color: tomato">please pull the backend</span>
          <span v-if="provider.address2"> , {{ provider.address2.toLowerCase() }}</span>
          <span v-if="provider.city"> , {{ provider.city.toLowerCase() }}</span>
          <span v-if="provider.state"> , {{ provider.state.toUpperCase() }}</span>
          <span v-if="provider.zip"> , {{ provider.zip }}</span>
        </td>
      </tr>
      <tr v-if="provider.phone">
        <td class="provider__info">
          <font-awesome-icon :icon="['fas', 'phone']" class="icon"/><b>Tel: </b><a :href="'tel:'+provider.phone">{{ provider.phone }}</a>
        </td>
      </tr>

      <tr v-if="provider.fax">
        <td class="provider__info">
          <font-awesome-icon :icon="['fas', 'fax']" class="icon"/>
          <b>Fax:</b> {{ provider.fax }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: "ProviderBio",
    props: {
      provider: Object,
      specialty: String,
      keywords: {
        type: Array,
        default: () => []
      }
    }
  }
</script>

<style scoped lang="scss">
  $color-font: darken(#58595b, 10%);
  table {
    text-align: left;
    width: 100%;
  }

  tr {
    font-size: 0.95em;
  }

  .table-container {
    padding: 1em 2em 1.5em;
    border-bottom: 1px solid lightgray;
  }

  .provider__avatar {
    width: 100px;
  }

  .provider__title {
    font-size: 1.5em;
  }

  .provider__info {
    color: $color-font;
    line-height: 1.8em;
  }

  .icon {
    margin-right: 0.5em;
  }

  .capitalize {
    text-transform: capitalize;
  }
</style>
